import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getProductHiearchy = createAsyncThunk('/getProductHiearchy', async () => {
  const response = await axios.get('/GetProductHiearchy');
  return response.data;
});
export const getSubHiearchy = createAsyncThunk('/GetSubHierarchyWithParent', async (parentCode) => {
  const response = await axios.get(`/GetSubHierarchyWithParent/${parentCode}`);
  return response.data;
});
export const getCampaignType = createAsyncThunk('/getCampaignType', async () => {
  const response = await axios.get('/GetCampaignType');
  return response.data;
});
export const getFlsList = createAsyncThunk('/getFlsList', async (hierarchyId) => {
  const response = await axios.get(`/GetFlsList/${hierarchyId}`);
  return response.data;
});

export const getLanguagelist = createAsyncThunk('/getLanguageList', async () => {
  const response = await axios.get('/GetLanguageList');
  return response.data;
});

export const getFlsAnswerList = createAsyncThunk('/getFlsAnswerList', async () => {
  const response = await axios.get('/GetFlsAnswerList');
  return response.data;
});

export const getFlsQuestionList = createAsyncThunk('/getFlsQuestionList', async () => {
  const response = await axios.get('/GetFlsQuestionList');
  return response.data;
});

export const deleteFls = createAsyncThunk('/deleteFls', async (flsData) => {
  const response = await axios.post(`/DeleteFls`, flsData);
  return response.data;
}); 

export const addFlsQuestionAnswer = createAsyncThunk('/addFlsQuestionAnswer',
  async (data) => {
    const response = await axios.post('/AddFlsQuestionAnswer', data);
    return response.data;
});

export const addFls = createAsyncThunk('/addFls',
  async (data) => {
    const response = await axios.post('/AddFls', data);
    return response.data;
});

export const addFlsQuestion = createAsyncThunk('/addFlsQuestion',
  async (data) => {
    const response = await axios.post('/AddFlsQuestion', data);
    return response.data;
});

export const addFlsAnswer = createAsyncThunk('/addFlsAnswer',
  async (data) => {
    const response = await axios.post('/AddFlsAnswer', data);
    return response.data;
});

export const getFlsLanguageList = createAsyncThunk('/getFlsLanguageList',
  async (flsId) => {
    const response = await axios.get(`/GetFlsLanguageList/${flsId}`);
    return response.data;
});

export const getFlsQuestionLanguageList = createAsyncThunk('/getFlsQuestionLanguageList',
  async (flsQuestionId) => {
    const response = await axios.get(`/GetFlsQuestionLanguageList/${flsQuestionId}`);
    return response.data;
});

export const getFlsAnswerLanguageList = createAsyncThunk('/getFlsAnswerLanguageList',
  async (flsAnswerId) => {
    const response = await axios.get(`/GetFlsAnswerLanguageList/${flsAnswerId}`);
    return response.data;
});

const flsSlice = createSlice({
  name: 'workOrderDetail',
  initialState: {
    loading: '',
    error: '',
    productHiearchyList: [],
    campaignTypeList:[],
    subHiearchyList:[],
    flsList: [],
    languageList: [],
    flsQuestionList: [],
    flsAnswerList: []
  },
  reducers: {
    setSelectedFls(state, action) {
      state.selectedFls = action.payload;
    },
    setSelectedFlsQA(state, action){
      state.selectedFlsQA = action.payload
    },
    setSelectedProductHiearchy(state, action){
      state.selectedProductHiearchy = action.payload
    },
    setSelectedMainFls(state, action){
      state.selectedMainFls = action.payload
    }
  },
  extraReducers: {
    [getProductHiearchy.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getProductHiearchy.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getProductHiearchy.fulfilled]: (state, action) => {
      state.productHiearchyList = action.payload;
      state.loading = 'Finished';
    },
    [getCampaignType.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getCampaignType.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getCampaignType.fulfilled]: (state, action) => {
      state.campaignTypeList = action.payload;
      state.loading = 'Finished';
    },
    [getSubHiearchy.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getSubHiearchy.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getSubHiearchy.fulfilled]: (state, action) => {
      state.subHiearchyList = action.payload;
      state.loading = 'Finished';
    },
    [getFlsList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getFlsList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsList.fulfilled]: (state, action) => {
      state.flsList = action.payload;
      state.loading = 'Finished';
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.languageList = action.payload;
      state.loading = 'Finished';
    },
    [getFlsAnswerList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getFlsAnswerList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsAnswerList.fulfilled]: (state, action) => {
      state.flsAnswerList = action.payload;
      state.loading = 'Finished';
    },
    [getFlsQuestionList.pending]: (state) => {
      state.loading = 'Loading';
    },
    [getFlsQuestionList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsQuestionList.fulfilled]: (state, action) => {
      state.flsQuestionList = action.payload;
      state.loading = 'Finished';
    },
    [deleteFls.pending]: state => {
      state.loading = 'Loading';
    },
    [deleteFls.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [deleteFls.fulfilled]: (state, action) => {
      state.response = action.payload;
      state.loading = 'Finished';
    },
    [addFlsQuestionAnswer.pending]: state => {
      state.loading = 'Loading';
    },
    [addFlsQuestionAnswer.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [addFlsQuestionAnswer.fulfilled]: (state, action) => {
      state.addResponse = action.payload;
      state.loading = 'Finished';
    },
    [addFls.pending]: state => {
      state.loading = 'Loading';
    },
    [addFls.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [addFls.fulfilled]: (state, action) => {
      state.addResponse = action.payload;
      state.loading = 'Finished';
    },
    [addFlsQuestion.pending]: state => {
      state.loading = 'Loading';
    },
    [addFlsQuestion.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [addFlsQuestion.fulfilled]: (state, action) => {
      state.addResponse = action.payload;
      state.loading = 'Finished';
    },
    [addFlsAnswer.pending]: state => {
      state.loading = 'Loading';
    },
    [addFlsAnswer.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [addFlsAnswer.fulfilled]: (state, action) => {
      state.addResponse = action.payload;
      state.loading = 'Finished';
    },
    [getFlsLanguageList.pending]: state => {
      state.loading = 'Loading';
    },
    [getFlsLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsLanguageList.fulfilled]: (state, action) => {
      state.flsLanguageList = action.payload;
      state.loading = 'Finished';
    },
    [getFlsQuestionLanguageList.pending]: state => {
      state.loading = 'Loading';
    },
    [getFlsQuestionLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsQuestionLanguageList.fulfilled]: (state, action) => {
      state.flsQuestionLanguageList = action.payload;
      state.loading = 'Finished';
    },
    [getFlsAnswerLanguageList.pending]: state => {
      state.loading = 'Loading';
    },
    [getFlsAnswerLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getFlsAnswerLanguageList.fulfilled]: (state, action) => {
      state.flsAnswerLanguageList = action.payload;
      state.loading = 'Finished';
    },
  }
});

export const flsActions = flsSlice.actions;

export default flsSlice;
